var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPixelWarLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 79,
    viewBox: "0 0 110 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.029 15.2139H100.183V19.1149H104.029V15.2139Z",
    fill: "#171222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.983 16.2748V18.0529H101.23V16.2748H102.983ZM105.077 14.1519H99.1367V20.1758H105.077V14.1519Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0531 76.2406H33.3226L33.293 67.7381V65.746H15.2658V67.8601L3.48897 67.8212V64.1874H1.05371L1.13047 52.2261H3.48897V49.4273H5.32239V41.8641H3.87798V36.194H5.32239V11.1798H3.74191V5.50791H5.32239V2.73917H21.5615V1.79267H25.408V2.73917H27.9375V7.50706H28.4748V2.73917H52.7698V7.38145H55.1632V2.73917H81.6771V1.06201H87.2681V2.73917H98.5948V5.91128H100.177V9.81227H98.5948V10.4156H100.285V16.0857H98.5948V19.0774H105.813V29.9718H99.406V30.9272H105.464V42.0764H106.162V45.7014H107.048V51.3716H106.171L106.195 54.4057L108.953 54.3632V62.1953H106.869V65.7424L45.0837 65.7531V76.1522H43.3654V77.9302L35.0531 77.9373V76.2406Z",
    fill: "#171222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2214 2.12299V3.80015H97.5481V6.97225H99.1303V8.75026H97.5481V11.4765H99.2385V15.0237H97.5481V20.1383H104.767V28.9098H98.361V31.9882H104.418V41.3417H98.7273V43.1356H105.116V46.7606H106.002V50.3078H105.116L105.159 55.4808L107.907 55.4383V61.1297H105.822V64.6787L44.037 64.6893V75.0884H42.317V76.8664L36.098 76.8717V75.1751H34.364L34.3378 67.7305V64.6787H14.2173V66.7893L4.53383 66.7592V63.12H2.10556L2.16836 53.2835H4.53383V50.4829H6.36726V40.7968H4.92285V37.2496H6.36726V10.1178H4.78678V6.57065H6.36726V3.80192H22.6046V2.85542H24.3578V3.80192H26.8873V8.56803H29.5179V3.80192H51.7196V8.44242H56.2063V3.80192H82.7202V2.12476H86.2179M88.3112 0.00176916H80.6269V1.67893H54.1129V6.31943H53.8129V1.67716H26.4511V0.730662H20.5113V1.67716H4.27566V4.44589H2.69518V12.239H4.27566V35.1302H2.83125V42.9233H4.27566V48.3635H2.44223V51.1641H0.0907116L0.0767559 53.2729L0.0139556 63.1094L0 65.2466H2.44223V68.8786L4.5286 68.8857L14.2121 68.9158L16.3124 68.9229V66.807H32.2462V67.734L32.2724 75.1857L32.2794 77.3016H34.0046V79H36.0997L42.3187 78.9929H44.4103V77.2149H46.1303V66.814L105.822 66.8052H107.915V63.2563H110V53.2853L107.874 53.3189L107.233 53.3295L107.226 52.4361H108.095V44.6429H107.209V41.0179H106.511V31.0363H106.86V18.0189H99.6414V17.1502H101.332V9.35708H101.224V4.8528H99.6414V1.67716H88.3147V0L88.3112 0.00176916Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.166 3.72395V5.50195H54.9192V3.72395H53.166Z",
    fill: "#171222",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7734 30.3197V32.0977H29.5266V30.3197H27.7734Z",
    fill: "#171222"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1141 56.748H2.34082V63.0038H10.1141V56.748Z",
    fill: "#171222"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08301 26.4264V6.16602H25.1704V10.1112H29.0605V14.5872H25.1704V18.5324H17.3884V26.4246H9.08301V26.4264ZM20.5999 14.0582V10.6438H17.3884V14.0582H20.5999Z",
    fill: "url(#paint0_linear_591_57764)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9086 6.43114V10.3764H28.7988V14.3216H24.9086V18.2668H17.1266V26.159H9.34463V6.43114H24.9086ZM17.1266 14.3234H20.8615V10.3781H17.1266V14.3234ZM25.432 5.90039H8.82129V26.6915H17.65V18.7993H25.432V14.8541H29.3221V9.84738H25.432V5.90216V5.90039ZM17.65 10.9071H20.3382V13.7908H17.65V10.9071Z",
    fill: "#1E1E1E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2292 6.1665H30.9238V26.4269H39.2292V6.1665Z",
    fill: "url(#paint1_linear_591_57764)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9675 6.43114V26.1608H31.1854V6.43114H38.9675ZM39.4908 5.90039H30.6621V26.6915H39.4908V5.90039Z",
    fill: "#1E1E1E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3494 26.4269V22.4799H50.0925V26.4269H41.7871V21.9492H45.6772V18.0039H49.5691V14.5877H45.6772V10.6425H41.7871V6.1665H50.0925V10.1117H57.3494V6.1665H65.6547V10.6425H61.7646V14.5877H57.8727V18.0039H61.7646V21.9492H65.6547V26.4269H57.3494Z",
    fill: "url(#paint2_linear_591_57764)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3938 6.43114V10.3764H61.5036V14.3216H57.6135V18.2668H61.5036V22.212H65.3938V26.1573H57.6118V22.212H49.8298V26.1573H42.0478V22.212H45.9379V18.2668H49.828V14.3216H45.9379V10.3764H42.0478V6.43114H49.8298V10.3764H57.6118V6.43114H65.3938ZM65.9171 5.90039H57.0884V9.84561H50.3531V5.90039H41.5244V10.9071H45.4145V14.8523H49.3047V17.7361H45.4145V21.6813H41.5244V26.688H50.3531V22.7428H57.0884V26.688H65.9171V21.6813H62.027V17.7361H58.1368V14.8523H62.027V10.9071H65.9171V5.90039Z",
    fill: "#1E1E1E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8672 26.4269V6.1665H83.9528V10.6425H76.1708V14.057H83.9528V18.5347H76.1708V21.9492H83.9528V26.4269H67.8672Z",
    fill: "url(#paint3_linear_591_57764)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6918 6.43114V10.3764H75.9098V14.3216H83.6918V18.2668H75.9098V22.212H83.6918V26.1573H68.1278V6.43114H83.6918ZM84.2152 5.90039H67.6045V26.6915H84.2152V21.6848H76.4332V18.8011H84.2152V13.7944H76.4332V10.9106H84.2152V5.90393V5.90039Z",
    fill: "#1E1E1E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8613 26.4269V6.1665H95.1649V21.9492H102.947V26.4269H86.8613Z",
    fill: "url(#paint4_linear_591_57764)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94.904 6.43114V22.2156H102.686V26.1608H87.122V6.43114H94.904ZM95.4273 5.90039H86.5986V26.6915H103.209V21.6848H95.4273V5.90039Z",
    fill: "#1E1E1E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0274 50.7877V42.8955H51.8599V50.7877H41.9531V34.4726H46.644V30.5273H61.2415V34.4726H65.9324V50.7877H56.0256H56.0274ZM56.0274 38.4196V35.1625H51.8599V38.4196H56.0274Z",
    fill: "url(#paint5_linear_591_57764)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9816 30.7925V34.7377H65.6724V50.5221H56.289V42.6299H51.5982V50.5221H42.2147V34.7377H46.9056V30.7925H60.9798M51.5964 38.6847H56.2872V34.8969H51.5964V38.6847ZM61.5032 30.2617H46.3822V34.2069H41.6914V51.0529H52.1215V43.1607H55.7657V51.0529H66.1957V34.2069H61.5049V30.2617H61.5032ZM52.1197 35.4277H55.7639V38.1539H52.1197V35.4277Z",
    fill: "#1E1E1E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2947 50.7697V46.8245H83.2205V50.7697H69.5039V30.5093H96.4156V34.4545H103.013V38.9305H96.4156V46.2919H103.013V50.7679H89.2965L89.2947 50.7697ZM89.2947 38.4015V34.987H83.2205V38.4015H89.2947Z",
    fill: "url(#paint6_linear_591_57764)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1541 30.7747V34.7199H102.752V38.6652H96.1541V46.5574H102.752V50.5026H89.5583V46.5574H82.9608V50.5026H69.7675V30.7729H96.1558M82.9625 38.6652H89.56V34.7199H82.9625V38.6652ZM96.6792 30.2422H69.2441V51.0333H83.4841V47.0881H89.035V51.0333H103.275V46.0266H96.6774V39.1959H103.275V34.1892H96.6774V30.244L96.6792 30.2422ZM83.4859 35.2489H89.0367V38.1326H83.4859V35.2489Z",
    fill: "#1E1E1E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6359 50.7213V46.7744H8.8125V30.4609H18.9827V34.4062H21.3359V38.1232H25.7546V34.4062H28.1062V30.4609H38.2781V46.7744H33.4546V50.7213H13.6359Z",
    fill: "url(#paint7_linear_591_57764)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0163 30.7265V46.511H33.1929V50.4562H13.8975V46.511H9.07412V30.7265H18.7209V34.6718H21.0742V38.3888H26.0163V34.6718H28.3695V30.7265H38.0163ZM38.5397 30.1958H27.8462V34.141H25.4929V37.858H21.5976V34.141H19.2443V30.1958H8.55078V47.0417H13.3742V50.987H33.7163V47.0417H38.5397V30.1958Z",
    fill: "#1E1E1E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2006 55.9038H15.3213V61.0167H32.2006V55.9038Z",
    fill: "#9F7133"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40.969 43.4541H39.2158V45.2321H40.969V43.4541Z",
    fill: "#D6BA69"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M40.969 45.2339H39.2158V47.0119H40.969V45.2339Z",
    fill: "#9F7133"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7209 57.6831H40.9678V59.4611H42.7209V57.6831Z",
    fill: "#9F7133"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2131 43.4541H37.46V48.7899H39.2131V43.4541Z",
    fill: "#9F7133"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6553 54.1257V52.3477H35.7093V54.1257H39.6553Z",
    fill: "#171222"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4346 64.5739V62.7959H35.7084V64.5739H39.4346Z",
    fill: "#171222"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M40.969 71.6885H39.2158V73.4665H40.969V71.6885Z",
    fill: "#D6BA69"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40.969 69.9102H39.2158V71.6882H40.969V69.9102Z",
    fill: "#9F7133"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M37.46 64.5742V66.3522V68.1302H39.2149V66.3522V64.5742H37.46Z",
    fill: "#D6BA69"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M37.46 48.79V50.5698V52.3478H39.2149V50.5698V48.79H37.46Z",
    fill: "#D6BA69"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M37.46 55.9038V58.4602V61.0167H40.9681V58.4602V55.9038H37.46Z",
    fill: "#D6BA69"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2131 61.0166H37.46V62.7946H39.2131V61.0166Z",
    fill: "#9F7133"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M40.969 54.1255H39.2158V55.9035H40.969V54.1255Z",
    fill: "#9F7133"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M40.969 54.1255H39.2158V55.9035H40.969V54.1255Z",
    fill: "#9F7133"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M40.969 61.0166H39.2158V62.7946H40.969V61.0166Z",
    fill: "#9F7133"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2131 54.1255H37.46V55.9035H39.2131V54.1255Z",
    fill: "#9F7133"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7093 55.9038H32.2012V57.6818H35.7093V55.9038Z",
    fill: "#9F7133"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2012 57.6831V59.3497V61.0162H35.7075V59.3497V57.6831H32.2012Z",
    fill: "#D6BA69"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2131 68.1304H37.46V73.4662H39.2131V68.1304Z",
    fill: "#9F7133"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5684 55.9037V54.1257H11.8152V52.3477H8.30713V54.1257H6.55396V55.9037H4.80078V61.0165H6.55396V62.7963H8.30713V64.5743H11.8152V62.7963H13.5684V61.0165H15.3216V55.9037H13.5684Z",
    fill: "#9F7133"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55396 55.9038H4.80078V61.0167H6.55396V55.9038Z",
    fill: "#D6BA69"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30689 61.0166H6.55371V62.7946H8.30689V61.0166Z",
    fill: "#D6BA69"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8137 58.5713H10.0605V60.3493H11.8137V58.5713Z",
    fill: "#D6BA69"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0608 62.7959H8.30762V64.5739H10.0608V62.7959Z",
    fill: "#D6BA69"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M103.607 55.6807H42.7217V61.6834H103.607V55.6807Z",
    fill: "url(#paint8_linear_591_57764)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M105.34 57.6831H103.587V59.4611H105.34V57.6831Z",
    fill: "url(#paint9_linear_591_57764)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4612 48.79H35.708V50.568H37.4612V48.79Z",
    fill: "#171222"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4612 47.0117H35.708V48.7897H37.4612V47.0117Z",
    fill: "#171222"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4612 45.2339H35.708V47.0119H37.4612V45.2339Z",
    fill: "#171222"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4612 43.4541H35.708V45.2321H37.4612V43.4541Z",
    fill: "#171222"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4612 55.9038H35.708V57.6818H37.4612V55.9038Z",
    fill: "#171222"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4612 54.1255H35.708V55.9035H37.4612V54.1255Z",
    fill: "#171222"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4612 52.3477H35.708V54.1257H37.4612V52.3477Z",
    fill: "#171222"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4612 50.5698H35.708V52.3478H37.4612V50.5698Z",
    fill: "#171222"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4612 61.2397H35.708V63.0178H37.4612V61.2397Z",
    fill: "#171222"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4612 59.4614H35.708V61.2394H37.4612V59.4614Z",
    fill: "#171222"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4612 57.6831H35.708V59.4611H37.4612V57.6831Z",
    fill: "#171222"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4612 66.5757H35.708V68.3537H37.4612V66.5757Z",
    fill: "#171222"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2158 73.4656V75.2437H40.969V73.4656H39.2158Z",
    fill: "#171222"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M37.46 73.4681V75.2461H39.2131V73.4681H37.46Z",
    fill: "#171222"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4612 69.9102H35.708V71.6882H37.4612V69.9102Z",
    fill: "#171222"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4612 68.1304H35.708V69.9084H37.4612V68.1304Z",
    fill: "#171222"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4612 71.6885H35.708V73.4665H37.4612V71.6885Z",
    fill: "#171222"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9541 55.9035V54.1255H32.2009V55.9035H33.9541Z",
    fill: "#171222"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M35.708 55.9035V54.1255H33.9548V55.9035H35.708Z",
    fill: "#171222"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9541 62.7966V61.0186H32.2009V62.7966H33.9541Z",
    fill: "#171222"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M35.709 62.7946V61.0166H33.9558V62.7946H35.709Z",
    fill: "#171222"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4749 57.6831H42.7217V59.4611H44.4749V57.6831Z",
    fill: "#171222"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7209 59.2383H40.9678V61.0163H42.7209V59.2383Z",
    fill: "#171222"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M40.969 52.3477H39.2158V54.1257H40.969V52.3477Z",
    fill: "#171222"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M40.969 50.5698H39.2158V52.3478H40.969V50.5698Z",
    fill: "#171222"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M40.969 48.79H39.2158V50.568H40.969V48.79Z",
    fill: "#171222"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M40.969 47.0117H39.2158V48.7897H40.969V47.0117Z",
    fill: "#171222"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7209 45.2339H40.9678V47.0119H42.7209V45.2339Z",
    fill: "#171222"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M40.969 62.7959H39.2158V64.5739H40.969V62.7959Z",
    fill: "#171222"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M40.969 64.5742H39.2158V66.3522H40.969V64.5742Z",
    fill: "#171222"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M40.969 66.3525H39.2158V68.1305H40.969V66.3525Z",
    fill: "#171222"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M40.969 68.1304H39.2158V69.9084H40.969V68.1304Z",
    fill: "#171222"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7209 69.9102H40.9678V71.6882H42.7209V69.9102Z",
    fill: "#171222"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7209 43.4541H40.9678V45.2321H42.7209V43.4541Z",
    fill: "#171222"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7209 71.6885H40.9678V73.4665H42.7209V71.6885Z",
    fill: "#171222"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2158 41.6761V43.4541H40.969V41.6761H39.2158Z",
    fill: "#171222"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M37.46 41.6781V43.4561H39.2131V41.6781H37.46Z",
    fill: "#171222"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5686 52.3477H11.8154V54.1257H13.5686V52.3477Z",
    fill: "#171222"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5686 62.7959H11.8154V64.5739H13.5686V62.7959Z",
    fill: "#171222"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3215 61.0166H13.5684V62.7946H15.3215V61.0166Z",
    fill: "#171222"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8137 50.5698H10.0605V52.3478H11.8137V50.5698Z",
    fill: "#171222"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0608 50.5698H8.30762V52.3478H10.0608V50.5698Z",
    fill: "#171222"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8137 64.5742H10.0605V66.3522H11.8137V64.5742Z",
    fill: "#171222"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0608 64.5742H8.30762V66.3522H10.0608V64.5742Z",
    fill: "#171222"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80054 55.9038H6.55371V54.1258H4.80054V55.9038Z",
    fill: "#171222"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55444 54.1255H8.30762V52.3475H6.55444V54.1255Z",
    fill: "#171222"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55444 64.5728H8.30762V62.7948H6.55444V64.5728Z",
    fill: "#171222"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80054 62.7959H6.55371V61.0179H4.80054V62.7959Z",
    fill: "#171222"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0459 55.9051V57.6831H4.79908V55.9051H3.0459Z",
    fill: "#171222"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04785 57.6834V59.4614H4.80103V57.6834H3.04785Z",
    fill: "#171222"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3215 54.1255H13.5684V55.9035H15.3215V54.1255Z",
    fill: "#171222"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M107.096 57.6831H105.343V59.4611H107.096V57.6831Z",
    fill: "#171222"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7209 55.9038H40.9678V57.6818H42.7209V55.9038Z",
    fill: "#171222"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M103.606 54.1255H40.9678V55.9035H103.606V54.1255Z",
    fill: "#171222"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_591_57764",
    x1: 19.1031,
    y1: 3.37959,
    x2: 18.9919,
    y2: 27.9178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E6DBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D9C7D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#BF9EB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#AD81A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A26F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9E6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#9A668E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#906085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#805576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#684561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#61405B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_591_57764",
    x1: 34.9814,
    y1: 3.49861,
    x2: 35.1626,
    y2: 27.1752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E6DBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D6C3D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#B892B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A57499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9E6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9B678E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#936187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#84587A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#704A69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#61405B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_591_57764",
    x1: 53.7401,
    y1: 3.38008,
    x2: 53.7024,
    y2: 27.6919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E6DBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#DFD0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CCB3C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AF84A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9E6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#9A668E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#906085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#805576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#684561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#61405B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_591_57764",
    x1: 75.8934,
    y1: 5.25539,
    x2: 75.9257,
    y2: 26.1792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E6DBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D9C7D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#B994B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9E6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#9A668E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#906085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#805576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#684561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#61405B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_591_57764",
    x1: 94.6294,
    y1: 4.1019,
    x2: 94.9326,
    y2: 25.6873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E6DBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D4BFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AD81A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9E6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#9A668E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#906085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#805576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#684561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#61405B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_591_57764",
    x1: 54.0823,
    y1: 28.4964,
    x2: 53.8634,
    y2: 50.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E3D6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B187A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9E6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9A668E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#906085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#805576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#684561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#61405B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_591_57764",
    x1: 86.3135,
    y1: 28.5402,
    x2: 86.2094,
    y2: 50.4601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E6DBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C9AEC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9E6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#9A668E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#916085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#805576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#694562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#61405B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_591_57764",
    x1: 23.5217,
    y1: 30.4751,
    x2: 23.5827,
    y2: 51.4962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E6DBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#CBB0C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B289AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#A37197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9E6991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9A668E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#906085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#805576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#684561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#61405B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_591_57764",
    x1: 73.1763,
    y1: 55.4949,
    x2: 73.153,
    y2: 61.5507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E6DBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#E5CFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E37D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#DF7B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#D5763C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C56E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#AD6235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#A35D33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_591_57764",
    x1: 104.468,
    y1: 57.6796,
    x2: 104.461,
    y2: 59.4647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6DBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E5D3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#E5BFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#E4AD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#E49E7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E39164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E38853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E38147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E37E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E37D3F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixelWarLogo);
export default __webpack_public_path__ + "static/media/pixel-war-logo.65da703e1edcb2ae05e3123484481657.svg";
export { ForwardRef as ReactComponent };